export const weatherIcon = {
Thunderstorm :"wi-thunderstorm",
Dizzle  :"wi-sleet",
Rain : "wi-storm-showers",
Snow :"wi-snow",
Atmosphere :"wi-fog",
Clear :"wi-day-sunny",
Clouds :"wi-day-fog"
}